function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-25986bc9-0f54-4df1-83c5-c08fdb66fb1f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m30.26,21.406v-10.186c0-5.635-4.585-10.22-10.301-10.22-5.635,0-10.22,4.585-10.22,10.22v10.186c0,5.139,3.816,9.392,8.76,10.104v4.49h-4.897c-.828,0-1.5.671-1.5,1.5s.672,1.5,1.5,1.5h12.794c.828,0,1.5-.671,1.5-1.5s-.672-1.5-1.5-1.5h-4.897v-4.49c4.945-.712,8.76-4.965,8.76-10.104Zm-17.521,0v-3.708h14.521v3.708c0,3.981-3.239,7.221-7.22,7.221h-.081c-3.981,0-7.22-3.239-7.22-7.221Z",
    style: {
      fill: "#e7e7e7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic1);
export default __webpack_public_path__ + "static/media/Mic_1.25f9283bc09533a7945ff7e84397f896.svg";
export { ForwardRef as ReactComponent };